import React from 'react';
import { Route, IndexRoute } from 'react-router';

import ConnectedPage from './containers/ConnectedPage';
import ConnectedCollectionPage from './containers/ConnectedCollectionPage';

const BASE_URL = '/c/:id';

const getRoutes = (appProps) => {
    const PageWithAppProps = (props) => (
        <ConnectedPage {...appProps} {...props} />
    );

    /*TODO: Add IndexRoute */
    return (
        <Route path={BASE_URL} component={PageWithAppProps}>
            <IndexRoute component={ConnectedCollectionPage} />
        </Route>
    );
};

export default getRoutes;
